import { Collapse } from '@mui/material';
import CustomTab from '@src/components/CustomTab/CustomTab';
import { Order } from '@src/components/Main/Chat/ChatMessage/ChatMessage';
import PageHeaderMobile from '@src/components/PageHeader/PageHeaderMobile';
import SearchBar from '@src/components/SearchBar';
import React, { Dispatch, SetStateAction, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Orders from './Orders';
import AcceptDelivery from './acceptDelivery';
import { OrderView } from '.';
import { SelectedItemsTextContainer } from '@src/components/CommonComponents/Common';

const StyledMobileContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100vh;
	overflow: hidden;
	width: 100%;

	#filter-container {
		display: flex;
		gap: 10px;
	}
`;

interface Props {
	view: OrderView;
	setView: (data: OrderView) => void;
	viewOrder: boolean;
	setViewOrder: Dispatch<SetStateAction<boolean>>;
	filteredRows: any;
	setFilteredRows: any;
	setSearchValue: any;
	searchValue: any;
	orders: any;
	setOrders: any;
	collapse: any;
	setCollapse: any;
}

const OrderMobileHomePage: React.FC<Props> = ({
	view,
	setView,
	viewOrder,
	setViewOrder,
	filteredRows,
	setFilteredRows,
	setSearchValue,
	searchValue,
	orders,
	setOrders,
	collapse,
	setCollapse,
}) => {
	const [tabValue, setTabValue] = useState('1');
	const [selectedItemIds, setSelectedItemIds] = useState<string[]>([]);

	const tabs = [
		{
			label: 'All Orders',
			value: '1',
			content: (
				<Orders
					filteredRows={filteredRows}
					setFilteredRows={setFilteredRows}
					setSearchValue={setSearchValue}
					searchValue={searchValue}
					orders={orders}
					setOrders={setOrders}
					collapse={collapse}
				/>
			),
		},
		{
			label: 'Accept Delivery',
			value: '2',
			content: (
				<AcceptDelivery
					view={view}
					setView={setView}
					viewOrder={viewOrder}
					setViewOrder={setViewOrder}
					filteredRows={filteredRows}
					setFilteredRows={setFilteredRows}
					setSearchValue={setSearchValue}
					searchValue={searchValue}
					orders={orders}
					setOrders={setOrders}
					collapse={collapse}
				/>
			),
		},
	];

	const navigate = useNavigate();

	const handleSearch = (value: any) => {
		setSearchValue(value);
		const filteredRows: any = orders?.filter((order: any) => {
			const lowerCaseValue = value?.toLowerCase();

			return (
				order?.firstname?.toLowerCase()?.includes(lowerCaseValue) ||
				order?.id?.toLowerCase()?.includes(lowerCaseValue)
			);
		});
		setFilteredRows(filteredRows);
	};
	const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
		setTabValue(newValue);
	};

	return (
		<StyledMobileContainer>
			<PageHeaderMobile
				title={tabValue === '1' ? 'Orders' : 'Accept Delivery'}
				setCollapse={setCollapse}
				collapse={collapse}
				onClick={() => {
					if (tabValue === '2') {
						setTabValue('1');
						return;
					}
					navigate(-1);
				}}
			/>
			{collapse ? (
				<Collapse
					in={collapse}
					style={{
						display: 'flex',
						gap: '15px',
						alignItems: 'center',
						flexShrink: 0,
						padding: '16px 16px 0px 16px',
					}}
				>
					<SearchBar
						style={{
							width: '328px',
							height: '36px',
						}}
						value={searchValue}
						onChange={handleSearch}
						isLoading={false}
						autoFocus
					/>
				</Collapse>
			) : null}
			<CustomTab
				sx={{
					flexShrink: 0,
					overflowY: 'hidden',
					height: 'calc(100vh - 170px)',
				}}
				tabValue={tabValue}
				handleTabChange={handleTabChange}
				tabs={tabs}
			/>
		</StyledMobileContainer>
	);
};

export default OrderMobileHomePage;
